import { trans } from '@spotahome/soyuz/client';

// The "inTransKey" key is used to prefix the addres when the RU is not a whole property
// for saying things like "Apartment in Calle X" when the RU is a room shared in an apt
const propertyTypeCorrelations = {
  whole: {
    property: 'apartments',
    transKey: 'property_show.breadcrumb.whole'
  },
  studio: {
    property: 'studios',
    transKey: 'property_show.breadcrumb.studio'
  },
  room_shared_apt: {
    property: 'rooms',
    inTransKey: 'property_show.breadcrumb.apartment_in',
    transKey: 'property_show.breadcrumb.whole'
  },
  room_residence: {
    property: 'residences',
    inTransKey: 'property_show.breadcrumb.residence_in',
    transKey: 'property_show.breadcrumb.residence'
  }
};

const composeLabel = (key, endText) => `${trans(key)} ${endText}`;

const getPropertyTypeCorrelation = type => propertyTypeCorrelations[type];

export const getListingAnchorText = (
  address,
  listingId,
  propertyType,
  isWhole
) => {
  const { inTransKey, transKey } = getPropertyTypeCorrelation(propertyType);

  return (
    (!address && composeLabel(transKey, listingId)) ||
    (isWhole && address) ||
    composeLabel(inTransKey, address)
  );
};
export default {
  getListingAnchorText
};
